import React, { Component } from 'react';
import styled from 'styled-components';
import { media } from '../../helpers/styleConstants';
import { Link } from 'react-router-dom';
import { Elevation } from 'rmwc/Elevation';
import { Theme } from 'rmwc/Theme';
import { LinearProgress } from 'rmwc/LinearProgress';
import { LegalNotices } from '../../components/LegalNotices';
import { Grid, GridCell, Button, Typography } from 'rmwc';
import { Card, CardPrimary, CardTitle, CardSupportingText, CardActions, CardAction } from 'rmwc/Card';
import { Text } from '../../components/Text';

const StyledCard = styled(Card)`
  min-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${media.phoneOnly`
    background-color: transparent !important;
    box-shadow: none !important;
  `};

  ${media.tabletLandscapeUp`
    max-width: 85%;
    min-width: 800px;
  `};
`;

const CardWidth = styled.div`
  ${media.phoneOnly`
    background-color: transparent !important;
    box-shadow: none !important;
  `};

  ${media.tabletLandscapeUp`
    width: 800px;
  `};
`;


export const StepWrapper = ({ children, headline, step, showSignInLink, additionalDisclaimer }) => {
  return (
    <div className="container-fluid">
      <div className="row mt-5">
        <div
          className="col-md-8 offset-md-2"
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}
        >
          <Text use="headline5">{headline}</Text>

          <StyledCard>
            <div className="secondary-linear-progress" style={{ width: '100%' }}>
              <LinearProgress className="mb-4 mt-2" style={{ width: '98%', margin: 'auto' }} progress={step / 12.0} />
            </div>
            {children}
          </StyledCard>

          <CardWidth>
            <Typography tag="div" use="caption" className="text-muted mt-2">{additionalDisclaimer}</Typography>
          </CardWidth>

          <LegalNotices />

          {showSignInLink && (
            <Text use="body1" className="mt-4 font-italic">
              Already have an account? <Link to="/login">Sign In</Link>
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};
